module.exports = __webpack_public_path__ + "static/media/logo_reactnative.e8db36d6.png";